/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { getKey, Key } from '@trello/keybindings';
import { maybeDisplayLimitsErrorOnCardAdd } from 'app/scripts/views/card/CardLimitsError';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/pop-over';
import { View } from 'app/scripts/views/internal/view';
import template from 'app/scripts/views/templates/list_copy';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';

class ListCopyView extends View {
  static initClass() {
    this.prototype.viewTitleKey = 'copy list';

    this.prototype.tagName = 'form';

    this.prototype.events = {
      'click .js-submit': 'submit',
      submit: 'submit',
      'keydown textarea[name="name"]': 'keydownEvent',
    };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'copyListInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    return this.listenTo(this.model.getBoard(), 'change:limits', this.render);
  }

  render() {
    const board = this.model.getBoard();
    this.$el.html(
      template({
        canCopyTotal: !board.isOverLimit('lists', 'totalPerBoard'),
        canCopyOpen: !board.isOverLimit('lists', 'openPerBoard'),
        name: this.model.get('name'),
      }),
    );

    return this;
  }

  keydownEvent(e) {
    if (getKey(e) === Key.Enter) {
      stopPropagationAndPreventDefault(e);
      this.submit(e);
      return;
    }
  }

  submit(e) {
    stopPropagationAndPreventDefault(e);
    const nameInput = this.getListName();

    // return if the user hasn't entered a title
    if (nameInput.val().trim() === '') {
      nameInput.focus().select();
      return;
    }

    const board = this.model.getBoard();
    const isOverLimit =
      board.isOverLimit('lists', 'totalPerBoard') ||
      board.isOverLimit('lists', 'openPerBoard');
    this.$('.js-limit-exceeded').toggleClass('hide', !isOverLimit);
    if (isOverLimit) {
      return;
    }

    if (this.model.cardList.length > 0) {
      let hasChecklists;
      let hasAttachments = (hasChecklists = false);
      this.model.cardList.forEach(function (card) {
        hasAttachments = hasAttachments || card.attachmentList.length > 0;
        return (hasChecklists = hasChecklists || card.checklistList.length > 0);
      });

      const options = {
        $elem: this.$(e.target),
        hasChecklists,
        hasAttachments,
        destinationBoard: board,
      };
      if (maybeDisplayLimitsErrorOnCardAdd(options)) {
        return;
      }
    }

    const listPos = board.listList.calcPos(
      this.model.getIndexInList() + 1,
      this.model,
      true,
    );

    const newListParams = {
      idListSource: this.model.id,
      idBoard: this.model.get('idBoard'),
      pos: listPos,
      name: nameInput.val().trim(),
      closed: false,
    };

    const taskName = 'create-list/copy';
    const source = 'copyListInlineDialog';
    const listSourceId = this.model.id || '';

    const traceId = Analytics.startTask({
      taskName,
      source,
    });

    const newList = board.listList.createWithTracing(
      newListParams,
      { modelCache: this.modelCache, traceId },
      tracingCallback(
        {
          taskName,
          traceId,
          source,
          attributes: {
            listSourceId,
            context: {
              list: {
                id: listSourceId,
              },
              board: {
                id: this.model.getBoard()?.id || '',
              },
              organization: {
                id: this.model.getBoard()?.getOrganization()?.id || '',
              },
            },
          },
        },
        (err, list) => {
          if (err) {
            board.listList.remove(newList);
          } else {
            Analytics.sendTrackEvent({
              action: 'copied',
              actionSubject: 'list',
              source: source,
              attributes: {
                listSourceId,
              },
              containers: {
                board: {
                  id: this.model.getBoard()?.id || '',
                },
                list: {
                  id: newList?.id || '',
                },
                organization: {
                  id: this.model.getBoard()?.getOrganization()?.id || '',
                },
              },
            });
          }
        },
      ),
    );

    PopOver.hide();
  }

  getListName() {
    return this.$('textarea[name="name"]');
  }
}

ListCopyView.initClass();
export { ListCopyView };
